import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import React from 'react';
import { ArticleProduct, ArticleProductProps } from '../ArticleProduct/ArticleProduct';
import { withProductProvider, WithProductProviderProps } from '@jbhi-fi/components/src/context/ProductProvider';
import { ContentfulImage } from '@jbhi-fi/components/src/ContentfulImage/ContentfulImage';
import AspectRatio from '@jbhi-fi/lanyard-ui/components/AspectRatio';
import { ARTICLE_HERO_IMAGE_ASPECT_RATIO } from '../ArticleHeader/ArticleHeader';
import { styles } from './ArticleProductWrapper.css';

type Props = {
  imgSrc: string;
  imgAlt: string;
  articleProducts: Array<ArticleProductProps>;
  className?: string;
};

export type ArticleProductWrapperProps = WithProductProviderProps<Props>;

export const ArticleProductWrapper = withProductProvider(({ imgSrc, imgAlt, articleProducts, className }: Props) => {
  return (
    <div className={classNames([styles.container, className])}>
      <AspectRatio ratio={ARTICLE_HERO_IMAGE_ASPECT_RATIO}>
        <ContentfulImage
          src={imgSrc}
          alt={imgAlt}
          aspectRatio={ARTICLE_HERO_IMAGE_ASPECT_RATIO}
          sizes="(max-width: 1124px) 100vw, 1124px"
        />
      </AspectRatio>
      <div className={styles.productContainer}>
        {articleProducts.map((product, i) => (
          <ArticleProduct key={i} {...product} />
        ))}
      </div>
    </div>
  );
});
